import { isServerSide } from '../Util';

function addRelatedHover(selector: string, target: string) {
    const buttons = document.querySelectorAll(selector);
    const dots = document.querySelectorAll(target);

    function handleMouseEnter() {
        dots.forEach((dot) => dot.classList.add('hover'));
    }

    function handleMouseLeave() {
        dots.forEach((dot) => dot.classList.remove('hover'));
    }

    buttons.forEach((button) => {
        button.addEventListener('mouseenter', handleMouseEnter);
        button.addEventListener('mouseleave', handleMouseLeave);
    });
}

function initListeners() {
    addRelatedHover('.stockholm-button', '.stockholm.dot');
    addRelatedHover('.goteborg-button', '.goteborg.dot');
    addRelatedHover('.stockholm.dot', '.stockholm-button');
    addRelatedHover('.goteborg.dot', '.goteborg-button');
}

if (!isServerSide()) {
    if (document.readyState !== 'loading') {
        initListeners();
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            initListeners();
        });
    }
}
